export default "<a class=\"{{logoClass}}\" routerLink=\"/home\">\n\t<img src=\"assets/images/logo-dark.png\" width=\"200\"  alt=\"logo\">\n</a>"